"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBell(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.946 0a6.894 6.894 0 016.892 6.657l.004.237v5.925l2.886 5.074c.484.97-.068 1.938-1.11 2.017l-.139.005-4.745-.001c.029.08.044.166.044.256A3.83 3.83 0 0111.946 24a3.83 3.83 0 01-3.83-3.83c0-.09.016-.176.045-.256H3.418c-1.086 0-1.704-.93-1.287-1.932l.057-.126 2.866-5.037V6.894A6.893 6.893 0 0111.947 0zm2.344 19.914H9.605c.028.08.044.166.044.256a2.298 2.298 0 004.598 0c0-.09.015-.176.043-.256zM11.946 1.532a5.36 5.36 0 00-5.355 5.14l-.004.222V13.057a.762.762 0 01-.005.052l.005-.088a.77.77 0 01-.088.357l-.012.022-2.838 4.983h16.597L17.41 13.4l-.012-.022a.762.762 0 01-.034-.073l.046.095a.77.77 0 01-.093-.275l-.002-.018a.763.763 0 01-.005-.06V6.893c0-2.962-2.4-5.362-5.364-5.362z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBell;
exports.default = _default;